import type { RegionGrain } from '~stores/kpi-envelope';

/**
 * Honest, human-readable sentence describing how region resolves for a KPI's
 * `RegionGrain`, keyed so adding or changing a grain never means editing every
 * card. `province` needs no extra line (the region filter applies exactly),
 * so it maps to `undefined` explicitly. The exhaustive `Record<RegionGrain, ...>`
 * makes the compiler enforce that a future grain is handled here instead of
 * silently returning `undefined`.
 */
const GRAIN_INFO: Record<RegionGrain, string | undefined> = {
    national: 'National only; not affected by the region filter.',
    businessUnit: 'Region resolves to business-unit level (province groups).',
    brand:
        'Region resolves to the Couche-Tard (Quebec) / Circle K (rest of Canada) app boundary.',
    province: undefined,
};

/**
 * Maps a card's `RegionGrain` to the honest region-behavior sentence, or
 * `undefined` for `province` (exact match, nothing extra to say). Pure and
 * synchronous: no React, store, or I/O, so the popover slice can call it
 * directly when building card content.
 */
export const grainInfo = (grain: RegionGrain): string | undefined =>
    GRAIN_INFO[grain];
